import React, {Component} from 'react';
import {
	Button,
	ContentSwitcher,
	Link,
	Select,
	SelectItem,
	SelectGroup,
	Slider,
	Switch,
	Tabs,
	Tab,
	Tile,
	Toggle,
	ToggleSmall
} from 'carbon-components-react';
import CCSlider from '../../components/CCSlider';
import PropertyComponent from '../../components/PropertyComponent';
import ParameterSlider from '../../components/ParameterSlider';
import ParameterToggle from '../../components/ParameterToggle';
import { IndexedParameterSelect, IndexedParameterValue } from '../../components/IndexedParameterSelect';
import LoggingToggle from '../../components/LoggingToggle';
import MidiDevicesDialogWrapper from '../../components/MidiDevicesDialogWrapper';
import NoteDivisionParameterSelect from '../../components/NoteDivisionParameterSelect';
import DevicePropertyButton from '../../components/DevicePropertyButton';
import DevicePropertySelect from '../../components/DevicePropertySelect';
import DevicePropertyToggle from '../../components/DevicePropertyToggle';
import PresetTable from '../../components/PresetTable';

import {
	FirmwareVersionField,
	ErrorCodeField,
	PSUVoltageField,
	MidiChannelSelector
} from '../../components/ConfigSettings';
import { Renew16 } from '@carbon/icons-react';

import * as midi from '../../js/rpl_midi.js';

midi.setProductId(0x01, 0x09, 'Radius');
midi.initialize();

class ExprDestinationSelector extends PropertyComponent {

	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}

	render() {
		return (
	  				<Select value={this.state.value} labelText="" defaultValue="Dest..." onChange={this.handleChange}>
					  <SelectItem value="0" text="Off"/>
					  <SelectItem value="1" text="Mix"/>
					  <SelectItem value="2" text="RM / FS Mix"/>
					  <SelectItem value="3" text="Shift 2X"/>
					  <SelectItem value="4" text="Frequency"/>
					  <SelectItem value="5" text="Track"/>
					  <SelectItem value="6" text="Mod Rate"/>
					  <SelectItem value="7" text="Mod Depth"/>
					  {/*<SelectItem value="8" text="Env Trig Threshold"/>*/}
					  <SelectItem value="9" text="Step Mod End"/>
	  				</Select>
		);
	}

	handleChange(event) {
		var newValue = event.target.value;
		this.setState({value: newValue});
		midi.setIndexedParameterValue(this.propId, newValue);
	}

	setValue(x) {
		this.setState({value : x});
	}
}

class ExprSlider extends PropertyComponent {

	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}

	render() {
		return <Slider min="0" max="100" step="0.1" stepMultiplier="40" labelText={this.labelText} onChange={this.handleChange} value={this.state.value} disabled={this.state.disabled} hideTextInput="1"/>
	}

	handleChange(props) {
		var newValue = Number(props.value);
		this.setState({value: newValue});
		midi.setParameterValue(this.propId, newValue / 100);
	}

	handleControlChange(ccNum, ccValue) {
		this.setValue(ccValue / 127);
	}

	setValue(x) {
		// Because the property ID has bit 0x2000 set, rpl_midi does not
		// scale the value
		this.setState({value : 100 * x / 8388608.0});
	}
}

class ExprDestination extends React.Component {
	constructor(props) {
		super(props);

		this.destPropId = props.destPropId;
		this.minPropId  = props.minPropId;
		this.maxPropId  = props.maxPropId;
	}

	render() {
		return (
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-4 bx--col-md-5 bx--col-lg-4">
	  				<ExprDestinationSelector propId={this.destPropId}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ExprSlider labelText="" propId={this.minPropId}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ExprSlider labelText="" propId={this.maxPropId}/>
	  			  </div>
	  			</div>
		);
	}
}

class ExprDestinations extends React.Component {

	createDestinations() {
		var children = [];

		for (var i = 0; i < 6; i++) {
			children.push(<ExprDestination
							destPropId={midi.PROPERTY_EXPR_DEST_1 + 3*i}
							minPropId={midi.PROPERTY_EXPR_MIN_1 + 3*i}
							maxPropId={midi.PROPERTY_EXPR_MAX_1 + 3*i}
						  />
						);
		}

		return children;
	}

	render() {
		return (
			<div>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-4 bx--col-md-5 bx--col-lg-4">
	  				Destination
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				Heel (Min)
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				Toe (Max)
	  			  </div>
	  			</div>
				{this.createDestinations()}
			</div>
		);
	}
}

class RemoteModeSelector extends PropertyComponent {
	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}

	createButtonAssignments() {
		if (this.state.value == 0) {
			return (
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset 1</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset 2</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset 3</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset 4</div>
	  			</div>
			);
		} else if (this.state.value == 1) {
			return (
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">AUX</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">ON</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset +</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset -</div>
	  			</div>
			);
		}
	}

	render() {
		return (
			<div>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <Select labelText="Remote Mode" value={this.state.value} onChange={this.handleChange}>
	  				<SelectItem text="Mode 1 - Presets 1-4" value="0"/>
	  				<SelectItem text="Mode 2 - Stomp & Presets" value="1"/>
	  			  </Select>
	  			</div>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">A</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">B</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">C</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">D</div>
	  			</div>
				{this.createButtonAssignments()}
			</div>
		);
	}

	handleChange(event) {
		var newValue = event.target.value;
		this.setState({value: newValue});
		midi.setDeviceProperty(this.propId, [newValue]);
	}

	setValue(x) {
		this.setState({value : x });
	}
}

const props = {
  exprSlider: {
	  hideTextInput: 1,
	  min: 0,
	  max: 100,
	  step: 0.1,
	  stepMultiplier: 40,
	  labelText: null,
  },
  tabs: {
    selected: 0,
    triggerHref: '#',
    role: 'navigation',
  },
  tab: {
    href: '#',
    role: 'presentation',
    tabIndex: 0,
  },
};

const note_divisions = [
	[ 0, "Off" ],
	[ 1, "8m" ],
	[ 2, "7m" ],
	[ 3, "6m" ],
	[ 4, "5m" ],
	[ 5, "4m" ],
	[ 6, "3m" ],
	[ 7, "2m" ],
	[ 8, "2m triplet" ],
	[ 9, "Dotted whole note" ],
	[ 10, "Whole note" ],
	[ 11, "Whole note triplet" ],
	[ 12, "Dotted 1/2 note" ],
	[ 13, "1/2 note" ],
	[ 14, "1/2 note triplet" ],
	[ 15, "Dotted 1/4 note" ],
	[ 16, "1/4 note" ],
	[ 17, "1/4 note triplet" ],
	[ 18, "Dotted 1/8th note" ],
	[ 19, "1/8th note" ],
	[ 20, "1/8th note triplet" ],
	[ 21, "Dotted 1/16th note" ],
	[ 22, "1/16th note" ],
	[ 23, "1/16th note triplet" ],
	[ 24, "Dotted 1/32nd note" ],
	[ 25, "1/32nd note" ],
	[ 26, "1/32nd note triplet" ],
	[ 27, "Dotted 1/64th note" ],
	[ 28, "1/64th note" ],
	[ 29, "1/64th note triplet" ],
	[ 30, "Dotted 1/128th note" ],
	[ 31, "1/128th note" ]
]

const EditorPage = () => (
    <div className="bx--grid bx--grid--full-width landing-page">
      <div className="bx--row editor-page__status">
        <div className="bx--col-sm-2 bx--col-md-4 bx--col-lg-8">
	    </div>
        <div className="bx--col-sm-2 bx--col-md-2 bx--col-lg-4">
	  		Status:&nbsp;
	  	    <span id="device-status"></span>
	    </div>
        <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">
	      <Button
	        className="editor-page__statusbtn"
	        disabled={false}
	        hasIconOnly={false}
	        iconDescription="Refresh"
	        kind="primary"
	        onClick={function noRefCheck(){midi.findMIDIDevice()}}
	        onFocus={function noRefCheck(){}}
	        renderIcon={Renew16}
	        size="default"
	        tabIndex={0}
	        tooltipAlignment="center"
	        tooltipPosition="bottom"
	        type="button"
	      >Refresh</Button>
	    </div>
      </div>
      <div className="bx--row landing-page__r2">
	    <div className="bx--col bx--no-gutter">
	      <Tabs {...props.tabs}>
	        <Tab {...props.tab} label="Edit">
	  		  <div className="bx--grid bx--grid--no-gutter bx--grid--full-width">
	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Mix" propId={0} ccNum={14}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Track -/+" propId={4} ccNum={18}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Carrier Freq." propId={3} ccNum={16}/>
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="FS- / RM / FS+" propId={1} ccNum={15}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Mod Rate" propId={5} ccNum={22}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Mod Amount" propId={6} ccNum={24}/>
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-4">
	  				<IndexedParameterSelect labelText="Shift 2X"
	  						defaultText="Off"
	  						propId={8194} ccNum={86}
	  				>
	  				  <IndexedParameterValue text="Up" value="2"/>
	  				  <IndexedParameterValue text="Off" value="1"/>
	  				  <IndexedParameterValue text="Down" value="0"/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-4">
	  				<IndexedParameterSelect labelText="Carrier Range" propId={8213} ccNum={87}>
	  				  <IndexedParameterValue text="Quantized" value="2"/>
	  				  <IndexedParameterValue text="High" value="1"/>
	  				  <IndexedParameterValue text="Low" value="0"/>
	  			 	</IndexedParameterSelect>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-4">
	  				<IndexedParameterSelect labelText="Mod Wave"
	  						defaultText="Triangle"
	  						propId={8210} ccNum={85}
	  				>
	  				  <IndexedParameterValue text="Triangle" value="0"/>
	  				  <IndexedParameterValue text="Square" value="1"/>
	  				  <IndexedParameterValue text="Random" value="2"/>
	  				  <IndexedParameterValue text="Random 2" value="3"/>
	  				  <IndexedParameterValue text="Step Mod" value="4"/>
	  				  <IndexedParameterValue text="X Mod -" value="5"/>
	  				  <IndexedParameterValue text="X Mod +" value="6"/>
	  				  <IndexedParameterValue text="Env Follower" value="7"/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-4">
	  				<ParameterToggle labelText="Env Trig" labelA="Off" labelB="On" propId={20}/>
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-4">
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-4">
	  				<IndexedParameterSelect labelText="Play Carrier via MIDI" propId={8215} ccNum={111}>
	  					<IndexedParameterValue text="Off" value={0}/>
	  					<IndexedParameterValue text="On" value={1}/>
	  					<IndexedParameterValue text="Global" value={2}/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-4">
	                  <NoteDivisionParameterSelect labelText="Mod Note Div" range="slow" propId={8211} ccNum={109}/>
	  			  </div>
	  			</div>
	 
	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-4">
	  				<ParameterSlider labelText="Step 1" propId={8} ccNum={70}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-4">
	  				<IndexedParameterSelect labelText="Step Mod Last Step" propId={8208} ccNum={78}>
	  				  <IndexedParameterValue text="1" value="1"/>
	  				  <IndexedParameterValue text="2" value="2"/>
	  				  <IndexedParameterValue text="3" value="3"/>
	  				  <IndexedParameterValue text="4" value="4"/>
	  				  <IndexedParameterValue text="5" value="5"/>
	  				  <IndexedParameterValue text="6" value="6"/>
	  				  <IndexedParameterValue text="7" value="7"/>
	  				  <IndexedParameterValue text="8" value="8"/>
	  			 	</IndexedParameterSelect>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-4">
	  				<ParameterToggle labelText="Step Mod Ramp" labelA="Off" labelB="On" propId={17} ccNum={79}/>
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Step 2" propId={9} ccNum={71}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Step 3" propId={10} ccNum={72}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Step 4" propId={11} ccNum={73}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Step 5" propId={12} ccNum={74}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Step 6" propId={13} ccNum={75}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Step 7" propId={14} ccNum={76}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Step 8" propId={15} ccNum={77}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<p>Sorry, the step modulator will use vertical sliders in the future.</p>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			</div>
			  </div>
	        </Tab>
	        <Tab {...props.tab} label="Ctrl Port">
	  		  <div className="bx--grid bx--grid--no-gutter bx--grid--full-width">
	  			<div className="bx--row editor-page__tab-ctrl">
	  			Expression destinations are saved to presets.  Click Save button at bottom of page to save global configuration.
	  			</div>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-2 bx--col-md-4 bx--col-lg-8">
	  				<DevicePropertySelect labelText="CTRL Port Mode" propId={midi.PROPERTY_CTRL_MODE}>
	  				  <SelectItem text="Off" value="0"/>
	  				  <SelectItem text="Expression" value="1"/>
	  				  <SelectItem text="Tap Tempo" value="2"/>
	  				  <SelectItem text="Remote" value="3"/>
	  				  <SelectItem text="MIDI In (TRS)" value="4"/>
	  				</DevicePropertySelect>

	  			  </div>
	  			  <div className="bx--col-sm-2 bx--col-md-4 bx--col-lg-8">
	  			    <CCSlider labelText="Expression Pedal Position" ccNum={4}/>
	  			  </div>
	  			</div>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <h1>Expression</h1>
	  			</div>
	  			<ExprDestinations/>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <h1>Remote</h1>
	  			</div>
	  			<RemoteModeSelector propId={midi.PROPERTY_REMOTE_BANK}/>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div class="bx--btn-set">
	  				<DevicePropertyButton kind="secondary" propId={midi.PROPERTY_CTRL_SAVE_CONFIG} dataBytes={[0]} refreshProps={true}>
	  				  Revert
	  				</DevicePropertyButton>
	  				<DevicePropertyButton kind="primary" propId={midi.PROPERTY_CTRL_SAVE_CONFIG} dataBytes={[1]}>
	  				  Save
	  				</DevicePropertyButton>
	  			  </div>
	  			</div>
	  		  </div>
	        </Tab>
	        <Tab {...props.tab} label="Preset">
	  		  <PresetTable numProgs={100} liveProg={128} allowRename={true}/>
	        </Tab>
	        <Tab {...props.tab} label="Config">
	  		  <div className="bx--grid bx--grid--no-gutter bx--grid--full-width">
	  			<div className="bx--row editor-page__tab-config">
	  			<FirmwareVersionField propId={midi.PROPERTY_FIRMWARE_VERSION}/>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  			<ErrorCodeField propId={midi.PROPERTY_ERROR_CODE}/>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  			  <DevicePropertySelect labelText="AUX Switch" propId={midi.PROPERTY_AUX_SWITCH_MODE}>
	  			    <SelectItem text="Tap/Tune" value="0"/>
	  			    <SelectItem text="Tap Tempo" value="1"/>
	  				<SelectItem text="Push-To-Tune" value="2"/>
	  				<SelectItem text="Push-To-Tune On/Off" value="3"/>
	  			    <SelectItem text="Preset Select" value="4"/>
	  			    <SelectItem text="Preset Shift" value="5"/>
	  			    <SelectItem text="Modulation On/Off" value="6"/>
	  			    <SelectItem text="LFO Hold" value="7"/>
	  			    <SelectItem text="LFO Hold On/Off" value="8"/>
	  			    <SelectItem text="LFO Trigger" value="9"/>
	  			  </DevicePropertySelect>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  			  <DevicePropertySelect labelText="Input/Output Configuration" propId={midi.PROPERTY_IO_CONFIG}>
	  			    <SelectItem text="Mono In / Mono Out" value="0"/>
	  			    <SelectItem text="Mono In / Stereo Out" value="1"/>
	  			    <SelectItem text="Stereo In / Stereo Out" value="2"/>
	  			  </DevicePropertySelect>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  			  <DevicePropertySelect labelText="Bypass Mode" propId={midi.PROPERTY_BYPASS_MODE}>
	  			    <SelectItem text="Analog" value="1"/>
	  			    <SelectItem text="DSP" value="2"/>
	  			  </DevicePropertySelect>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  			  <MidiChannelSelector propId={midi.PROPERTY_MIDI_CHANNEL}/>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  				<DevicePropertyToggle labelText="Play Carrier via MIDI" labelA="Off" labelB="On" propId={midi.PROPERTY_RECEIVE_MIDI_NOTE}/>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  				<DevicePropertyToggle labelText="Receive MIDI Clock" labelA="Off" labelB="On" propId={midi.PROPERTY_RECEIVE_MIDI_CLOCK}/>
	  			</div>
	  {/*
	  			<div className="bx--row editor-page__tab-config">
	  				<DevicePropertyToggle labelText="Send MIDI Active Sensing" labelA="Off" labelB="On" propId={midi.PROPERTY_ACTIVE_SENSING}/>
	  			</div>
				*/}
	  			<div className="bx--row editor-page__tab-config">
	  				<DevicePropertyToggle labelText="Lock Presets" labelA="Off" labelB="Locked" propId={midi.PROPERTY_PROG_DATA_LOCKED}/>
	  			</div>
	  		  </div>
	        </Tab>
	        <Tab {...props.tab} label="Help">
			  <h3>Resources</h3>
  				<Link href="https://redpandalab.freshdesk.com/support/home">Knowledge Base</Link><br/>
				<Link href="http://www.redpandalab.com/downloads/">User Manuals and Firmware Updates</Link><br/>
				<Link href="http://www.redpandalab.com/contact/">Contact Us</Link><br/>

	  		  <h3>Expression Pedal</h3>
  				<p>To assign the expression pedal to any combination of knobs:
  				<ol>
  				  <li>1. Hold the right footswitch while pluggin in the expression pedal (right LED will blink orange 3x).</li>
  				  <li>2. Move expression pedal to the heel down position.</li>
  				  <li>3. Adjust knobs for the desired sound.</li>
  				  <li>4. Move expression pedal to the toe down position.</li>
  				  <li>5. Adjust knobs for the desired sound.</li>
  				  <li>6. Hold the right footswitch for 2 seconds to save (right LED will blink green).</li>
  				</ol>
  				</p>
	
  			  <h3>Limitations</h3>
				<ul>
  	  		  	  <li>The web editor does not reflect changes made by another MIDI device.
  	  			      Hit Refresh to update.</li>
				</ul>

 			  <h3>Troubleshooting</h3>
	  		  <div className="bx--row editor-page__tab-help">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  		        <MidiDevicesDialogWrapper/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  		        <LoggingToggle/>
	  			  </div>
	  		  </div>
	        </Tab>
	      </Tabs>
	    </div>
      </div>
      <div className="bx--row landing-page__r3">
      </div>
    </div>
);

export default EditorPage;

